module.exports = __webpack_public_path__ + "/images/logo-af-carters.e502635.png";